import script from "./MoleculeDevolutionLicenseModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeDevolutionLicenseModal.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeDevolutionLicenseModal.vue?vue&type=style&index=0&id=74481f67&lang=css"

const __exports__ = script;

export default __exports__